var trendingUpOutline = "https://shopfront-cdn.tekoapis.com/static/f8a98e7b6265d7ec.svg";

export { trendingUpOutline as default };
